module.exports = __webpack_public_path__ + "img/SES_235330020.cc4c4045.jpg";